export default __webpack_public_path__ + "static/media/imgUp.60f29ebe.svg";